import gql from 'graphql-tag'
import { historyFragment } from "@/graphql/history/historyFragments";


// export const PROJECTHISTORY = gql`
//     query history(
//         $args: ID
//         $page: Int
//         $first: Int
//     ){
//         history(
//             args: $args
//             page: $page
//             first: $first
//         ){
//             data{
//                 ...historyFragment
//             }
//         }
//     }
//     ${historyFragment}
// `
export const HISTORY = gql`
    query history(
        $args: historyArgsInput!
        $page: Int = 0
        $first: Int = 50
        $orderBy: String = "id"
        $orderSort: SortOrder = DESC
    ){
        history(
            args: $args
            page: $page
            first: $first
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...historyFragment
            }
        }
    }
    ${historyFragment}
`